import { render, staticRenderFns } from "./ThreatCanvasControls.vue?vue&type=template&id=de8da8ae&scoped=true"
import script from "./ThreatCanvasControls.vue?vue&type=script&lang=js"
export * from "./ThreatCanvasControls.vue?vue&type=script&lang=js"
import style0 from "./ThreatCanvasControls.vue?vue&type=style&index=0&id=de8da8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8da8ae",
  null
  
)

export default component.exports